<!--图生视频-->
<template>
  <div class="wsVideo-container">
    <div class="tsv-title" :style="{ color: theme.worksColor2 }">AI文生视频</div>

    <div class="ts-video-info-box flex">
      <div class="ts-left-box">

        <div class="gd-box">
          <div class="ts-part2 ">
            <div class="flex ac jb">
              <!--<span style="color: #EEEEEE4d">(非必填)</span>-->
              <div>创意描述</div>
              <div>
                <el-popover
                  v-model="hasPopover"
                  placement="right"
                  width="400"
                  trigger="manual"
                  popper-class="custom-popover"
                >
                  <template>
                    <div class="lg-title-box flex ac cr">
                      <div class="mr15" :class="lgTitle==1?'lg-title-active': ''" @click="handleLgTitle(1)">灵感词库</div>
                      <div :class="lgTitle==2?'lg-title-active': ''" @click="handleLgTitle(2)">我的预设</div>
                    </div>

                    <div v-if="lgTitle==1" class="ling-gan-pro">
                      <div class="every-lg-box" v-for="(item,index1) in promptList" :key="index1">
                        <p class="mb10">{{item.name}}</p>
                        <div class="flex ac fw">
                          <div class="every-ele-box" v-for="(ele,index2) in item.list" :key="index2">
                            <el-popover
                              placement="top-start"
                              trigger="hover"
                              v-model="ele.popoverVisible"
                            >
                              <video ref="videoPlayer" autoplay
                                     loop
                                     muted
                                     @contextmenu.prevent v-show="item.popoverVisible"
                                     style="width: 150px;height: 100%;object-fit: contain"
                                     :src="ele.demo_url"></video>
                              <!-- 触发元素 -->
                              <template v-slot:reference>
                                <p class="every-lg-p"
                                   :class="choosedLgList.findIndex(user => user.name == ele.name)>-1 ? 'choosed-active-lg' :''"
                                   @mouseenter="item.popoverVisible = true" @click.stop="insertButton(ele,item)"
                                   @mouseleave="item.popoverVisible = false">{{ele.name}}</p>
                              </template>
                            </el-popover>


                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="lgTitle==2" class="my-ys-box">
                      <div class="flex ac jb">
                        <el-input
                          size="mini"
                          v-model="searchText"
                          placeholder="请输入搜索内容"
                          @input="handleSearch"
                        ></el-input>
                        <el-button size="mini" style="margin-left: 10px" icon="el-icon-plus" @click="showYsDialog=true">
                          新增预设
                        </el-button>
                      </div>
                      <div class="ys-list-box">
                        <div class="every-ys-box cr"
                             v-for="(item, index) in ysList"
                             :key="index"
                             @click="chooseMyys(item)"
                             @mouseover="hoverIndex = index"
                             @mouseleave="hoverIndex = null"
                        >
                          <p class="te">{{ item.title }}</p>
                          <p class="te2">{{ item.content }}</p>
                          <img v-if="hoverIndex === index" class="del-box cr" @click.stop="handleDelYs(item)"
                               src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/18.2_Icon_1.png"
                               alt="">
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-slot:reference>
                    <div class="flex ac cr jfe" :class="chooseck?'ck-active': ''" style="width: 80px;"
                         @click.stop="handleLgck">
                      <i class="el-icon-s-opportunity fs14"></i>
                      <p>灵感词库</p>
                    </div>
                  </template>

                </el-popover>
              </div>
            </div>
            <div class="mt15 bbox cy-input-box">
              <div class="placeholder-box" v-if="hasPlaceholder">请描述你想生成的视频内容</div>
              <div
                style="width: 100%;height: 100%;line-height: 30px"
                contenteditable="true"
                @paste="handlePaste"
                ref="editableDiv"
                @input="handleInput"
                v-html="content"
              >
              </div>
            </div>
            <div class="cy-handle-box flex ac jfe">
              <div class="handle-box cr mr10" @click="handleCyDel()">
                <i class="el-icon-delete"></i>
              </div>
              <div class="handle-box cr" @click="handleCySave">
                <i class="el-icon-document-checked"></i>
              </div>

            </div>

            <div class="part1-md2 mt15">
              <div class="title2 flex ac jb">
                <p>推荐尝试</p>
                <div class="part1-md3 flex ac">
                  <div v-for="(item, index) in tjList" :key="index" class="every-md3-img te cr"
                       @click="handleUseTj(item)">
                    {{item.title}}
                  </div>

                </div>
                <div class="refresh flex ac jc cr" @click="getVideoPromptRecommend">
                  <i class="el-icon-refresh" style="color: #01FBF5;font-size: 15px"></i>
                </div>
              </div>
            </div>


          </div>
          <div class="title1"><span style="color: red">*</span>参数设置</div>
          <div class="ts-part2">
            <div class="flex ac jb" style="width: 100%">
              <p>创意想象力</p>
              <div style="width: 50%">
                <el-slider v-model="cfg_scale" :min="0" :max="1" :step="0.05"
                           :format-tooltip="formatTooltip"></el-slider>
              </div>
              <p>创意相关度</p>
            </div>
          </div>

          <div class="ts-part3 mb15 flex ac">
            <div class="flex ac cr">
              <p>生成模式:</p>
              <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                popper-class="custom-popover2"
              >
                <template>
                  <div style="color: #fff">
                    标准: 5秒360积分/条 <br>
                    标准: 10秒720积分/条 <br>
                    高品质:5秒600积分/条<br>
                    高品质:10秒1200积分/条
                  </div>
                </template>
                <template slot="reference">
                  <i class="el-icon-warning-outline"></i>
                </template>
              </el-popover>
            </div>
            <div class="flex ac ml15">
              <div class="every-choose-box" :class="mode=='std'? 'every-choose-active-box':''"
                   @click="handleChooseMode('std')">标准
              </div>
              <div class="every-choose-box" :class="mode=='pro'? 'every-choose-active-box':''"
                   @click="handleChooseMode('pro')">高品质
              </div>
            </div>
          </div>

          <div class="ts-part3 flex ac">
            <p>生成时间:</p>
            <div class="flex ac ml15">
              <div class="every-choose-box" :class="duration==5? 'every-choose-active-box':''"
                   @click="handleChooseDuration(5)">5s
              </div>
<!--              <div class="every-choose-box" :class="duration==10? 'every-choose-active-box':''"-->
<!--                   @click="handleChooseDuration(10)">10s-->
<!--              </div>-->
            </div>
          </div>

          <div class="ts-part3 flex ac">
            <p>视频比例:</p>
            <div class="flex ac ml15">
              <div class="every-bl-box" :class="aspect_ratio=='16:9'? 'every-choose-active-box':''"
                   @click="handleChooseAspect('16:9')">
                <div class="oneLl"></div>
                <p>16:9</p>
              </div>
              <div class="every-bl-box" :class="aspect_ratio=='9:16'? 'every-choose-active-box':''"
                   @click="handleChooseAspect('9:16')">
                <div class="twoLl"></div>
                <p>9:16</p>
              </div>
              <div class="every-bl-box" :class="aspect_ratio=='1:1'? 'every-choose-active-box':''"
                   @click="handleChooseAspect('1:1')">
                <div class="threeLl"></div>
                <p>1:1</p>
              </div>
            </div>
          </div>

          <div class="title1">不希望出现的内容 <span style="color: #EEEEEE4d">(非必填)</span></div>


          <div class="no-xq-box">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="写下你不希望在视频中呈现的内容。例如：动画、模糊、变形、毁容、低质量、拼贴、粒状、标志、抽象、插图、计算机生成、扭曲 …"
              v-model="negative_prompt">
            </el-input>
          </div>
        </div>


        <div class="ts-part4 flex ac jc">
          <div class="btn-hc cr" @click="handleJLCreate('')">立即生成 <span class="fs15">({{needJf}})积分</span></div>
        </div>

      </div>
      <div class="ts-middle-box">

        <div class="has-video-box" v-if="chooseVideoUrl">
          <div class="video-part1">
            <video ref="videoPlayer2" controls="" :autoplay="false"
                   style="width: 100%;height: 100%;object-fit: contain"
                   :src="chooseVideoUrl"></video>
          </div>
          <div class="video-part2 flex ac jfe">
            <div class="handle-box cr" @click="handleDownVideo">
              <i class="el-icon-download"></i>
            </div>
            <div class="handle-box cr" @click="handleDelVideo()">
              <i class="el-icon-delete"></i>
            </div>
          </div>
        </div>
        <div class="no-video-info flex jc colu" v-else>
          <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/ts18.1_Icon_3.png" alt="">
          <p>快去生成你的创意吧~</p>
        </div>
        <div class="tip-box">
          内容由人工智能模型生成，不代表平台的观点、立场或态度，请合理友善地使用生成内容~
        </div>

      </div>
      <div class="ts-right-box">
        <div class="ts-part5 flex ac jb">
          <p>生成历史</p>
          <!--          <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/ts18.1_Icon_3.png" alt="">-->
        </div>
        <div class="no-history cr" v-if="videoList.length<=0">
          暂无记录
        </div>
        <div class="has-video cr" v-else>
          <div class="proceed-ing flex ac jc colu bbox" v-for="(item,index) in videoList" :key="index"
               :class="choosedViedoId==item.id?'video-active': ''" @click="chooseVideo(item)">
            <div class="" v-if="item.status!=3 && item.status!=4">
              <i class="el-icon-loading mb05"></i>
              <p>视频生成中...</p>
            </div>
            <div class="fail-video flex ac colu jc" v-if="item.status==4">
              <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/Icon_Failed.png" alt="">
              <p>视频生成失败</p>
              <p class="fail-del-box" @click="handleFailDel(item)">
                <i class="el-icon-delete"></i>
              </p>
            </div>
            <div class="success-video cr bbox" v-if="item.status==3">
              <img :src="item.cover" alt="cover">
              <p class="time-text">{{item.duration}}s</p>
              <p class="down-box" @click.stop="handleDownVideo(item)">
                <i class="el-icon-download"></i>
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>

    <el-dialog
      title="新增预设"
      :visible.sync="showYsDialog"
      width="30%">

      <div class="mb20 dialogInfo">
        <div class="mb10" style="color: #FAFAFAb3"><span style="color:#FF4545 ">*</span>预设名称</div>
        <el-input
          v-model="ysTitle"
          placeholder="请输入预设名称"
          @input="handleSearch"
        ></el-input>
      </div>
      <div class="dialogInfo">
        <div class="mb10" style="color: #FAFAFAb3"><span style="color:#FF4545 ">*</span>预设内容</div>
        <el-input
          type="textarea"
          :rows="7"
          placeholder="请输入预设内容"
          v-model="ysContent">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button style="color: #FAFAFA;background: #CCCCCC4d;border: none" @click="showYsDialog = false">取 消</el-button>
    <el-button style="color: #FFFFFF;background: #6C14FF;border: none" @click="handleSaveYs">保 存 </el-button>
  </span>
    </el-dialog>
  </div>
</template>
<script>
  import {
    uploadComplete, videoPromptRecommend, videoPrompt,
    getVideoGenerate, postVideoGenerate, delVideoGenerate,
    getUserPrompt, postUserPrompt, delUserPrompt,
  } from '../api/user'
  import {throttle} from "../../utils";

  export default {
    name: '',
    data() {
      return {
        needParam: {},
        uploadUrl: '',
        uploadDir: '',
        upImageUrl: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/lang-zh.png',
        choosedId: 1,
        showButton1: false,
        showButton2: false,
        tjList: [],
        content: '',
        isComposing: false,
        savedRange: null, // 用于保存光标位置
        buttonCount: 0,
        lgList: [{id: '111', label: '111'}, {id: '222', label: '222'},
          {id: '333', label: '333'},],
        hasPlaceholder: true,
        promptList: [],
        hasPopover: false,
        choosedLgList: [],
        chooseck: false,
        lgTitle: 1,
        // 接口需要参数
        prompt: '',
        negative_prompt: '',
        cfg_scale: 0.5,
        mode: 'std',
        duration: '5',
        aspect_ratio: '16:9',
        searchText: '',
        timeout: null,
        ysList: [],
        showYsDialog: false,
        ysTitle: '',
        ysContent: '',
        hoverIndex: null,
        videoList: [],
        choosedViedoId: null,
        chooseVideoUrl: '',
        pollingInterval: null,
      }
    },
    computed: {
      myHeaders() {
        return {'x-token': window.localStorage.getItem('xcToken') || ''}
      },
      theme() {
        return this.$store.getters.getTheme;
      },
      needJf() {
        if (this.mode == 'std') {
          if (this.duration == 5) {
            return 360
          }
          if (this.duration == 10) {
            return 720
          }
        }
        if (this.mode == 'pro') {
          if (this.duration == 5) {
            return 600
          }
          if (this.duration == 10) {
            return 1200
          }
        }
      }
    },
    created() {
      this.getVideoPromptRecommend()
      this.getVideoPrompt()
      this.gGetVideoGenerate()
    },
    methods: {
      // 查询作品
      gGetVideoGenerate() {
        getVideoGenerate({type: 'text'}).then(res => {
          this.videoList = res.data.list
          // const array = res.data.list
          // if (array.length > 0) {
          //   for (let i = 0; i < array.length; i++) {
          //     if (array[i].status == 3) {
          //       this.choosedViedoId = array[i].id
          //       this.chooseVideoUrl = array[i].url
          //       // this.washData(array[i].org_data)
          //       break
          //     }
          //   }
          // }
        })
      },
      // 处理json文件
      washData(str) {
        if (str) {
          const obj = JSON.parse(str)
          this.hasPlaceholder = false
          this.choosedLgList = JSON.parse(obj.orgChoosedList)
          this.content = obj.orgContent
        } else {
          this.content = ''
          this.choosedLgList = []
        }
      },
      chooseVideo(item) {
        if (item.status == 3) {
          this.choosedViedoId = item.id
          this.chooseVideoUrl = item.url
        }
        if (item.status == 4) {
          this.choosedViedoId = item.id
          this.chooseVideoUrl = ''
        }
        this.aspect_ratio = item.aspect_ratio
        this.mode = item.mode
        this.duration = item.duration
        this.negative_prompt = item.negative_prompt
        this.cfg_scale = item.cfg_scale
        this.washData(item.org_data)
      },
      getVideoPrompt() {
        videoPrompt().then(res => {
          this.promptList = res.data
        })
      },
      getVideoPromptRecommend() {
        videoPromptRecommend({type: 'text'}).then(res => {
          this.tjList = this.getRandomThree(res.data)
        })
      },
      // 清空创意
      handleCyDel() {
        const editableDiv = this.$refs.editableDiv;
        editableDiv.innerHTML = ''; // 清空所有内容
        this.content = ''
        this.choosedLgList = []
        this.hasPlaceholder = true
      },
      getPlainText() {
        const editableDiv = this.$refs.editableDiv;
        // 使用 textContent 获取纯文本
        const plainText = editableDiv.textContent;
        return plainText;
      },

      // 保存创意
      handleCySave() {
        postUserPrompt({content: this.getPlainText()}).then(res => {
          this.$message.success(res.msg)
        }).catch(error => {
          this.$message.error(error.msg)
        })
      },
      // 使用推荐尝试
      handleUseTj(val) {
        this.hasPlaceholder = false
        this.content = val.content
      },

      getRandomThree(arr) {
        // 检查数组长度是否大于 3
        if (arr.length <= 3) {
          return result;
        } else {
          // 创建一个新数组用于存储随机结果
          const result = [];
          const copy = [...arr]; // 复制原数组，避免修改原数组
          // 随机取出 3 个元素
          for (let i = 0; i < 3; i++) {
            const randomIndex = Math.floor(Math.random() * copy.length); // 随机索引
            result.push(copy[randomIndex]); // 将随机元素加入结果数组
            copy.splice(randomIndex, 1); // 从复制数组中移除已选元素
          }
          return result;
        }
      },
      handleLgTitle(val) {
        this.lgTitle = val
        if (val == 2) {
          this.performSearch();
        }
      },
      handleSearch() {
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => {
          this.performSearch();
        }, 300);
      },
      performSearch() {
        getUserPrompt({keyword: this.searchText}).then(res => {
          this.ysList = res.data
        })
      },
      handleLgck() {
        this.hasPopover = !this.hasPopover
        this.chooseck = !this.chooseck
      },

      formatTooltip(val) {
        if (val * 1 >= 0.75) {
          return val + '(数值较大)，有小概率出现图片和描述内客冲突导致的画面错误';
        } else {
          return val
        }
      },

      handeleChooseTitle(val) {
        this.choosedId = val
      },
      showClickEvent1() {
        this.showButton1 = true;
      },
      hideClickEvent1() {
        this.showButton1 = false;
      },
      showClickEvent2() {
        this.showButton2 = true;
      },
      hideClickEvent2() {
        this.showButton2 = false;
      },
      // 保存预设
      handleSaveYs() {
        if (!this.ysTitle) {
          this.$message.error('请填写预设名称！')
          return false
        }
        if (!this.ysContent) {
          this.$message.error('请填写预设内容！')
          return false
        }

        postUserPrompt({title: this.ysTitle, content: this.ysContent}).then(res => {
          this.$message.success(res.msg)
          this.ysList = ''
          this.ysContent = ''
          this.showYsDialog = false
          this.performSearch()
          this.$store.dispatch('updatePoints')
        }).catch(error => {
          this.$message.error(error.msg)
        })
      },
      // 下载视频
      async handleDownVideo(item) {
        var response = ''
        if (item.url) {
          response = await fetch(item.url);
        } else {
          response = await fetch(this.chooseVideoUrl);
        }
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = new Date().getTime() + '.mp4';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      // 删除失败视频
      handleFailDel(item) {
        this.$confirm('此操作将永久删除该条视频, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delVideoGenerate({id: item.id}).then(res => {
            this.$message.success(res.msg)
            this.gGetVideoGenerate()
          }).catch(error => {
            this.$message.error(error.msg)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      // 删除视频
      handleDelVideo() {
        this.$confirm('此操作将永久删除该条视频, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delVideoGenerate({id: this.choosedViedoId}).then(res => {
            this.$message.success(res.msg)
            this.gGetVideoGenerate()
          }).catch(error => {
            this.$message.error(error.msg)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      // 选择我的预设
      chooseMyys(item) {
        this.hasPlaceholder = false
        this.content = item.content
        this.choosedLgList = []
      },
      // 删除预设
      handleDelYs(item) {
        this.$confirm('此操作将永久删除该条预设, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delUserPrompt({id: item.id}).then(res => {
            this.$message.success(res.msg)
            this.performSearch()
          }).catch(error => {
            this.$message.error(error.msg)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },

      beforeAvatarUpload(file) {
        this.loading = this.$loading({
          lock: true,
          text: '上传中,请等待...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.6)'
        });
        const that = this
        var file_type = file.name.split('.').slice(-1)
        var file_name = that.uploadDir + Date.parse(new Date()) + '' + parseInt(Math
          .random() * 100) + '.' + file_type
        that.needParam.key = file_name
        that.uploadSize = file.size

        const fileExtension = file.name.split('.').pop().toLowerCase()
      },
      handleFileUpSuccess(file) {
        const url = `${this.uploadUrl}/${this.needParam.key}`
        uploadComplete({
          file_type: 'image',
          size: this.uploadSize,
          url: url
        }).then(res => {
          if (res.data.url && res.data.file_id) {
            this.file_id = res.data.file_id
            this.upImageUrl = res.data.url
            this.$message.success('上传成功')
            this.loading.close();
          }
        }).catch(() => {
          this.loading.close();
        })

        this.$refs.upload && this.$refs.upload.clearFiles();
      },
      handleRemove() {
        this.upImageUrl = ''
        this.$refs.upload && this.$refs.upload.clearFiles();
      },
      handleResetUp() {
        this.upImageUrl = ''
        this.file_id = ''
        this.$refs.upload && this.$refs.upload.clearFiles();
      },

      handleFileUpError() {
        this.$message.error('上传失败，请重新上传')
        this.loading.close();
      },

      handleChooseMode(val) {
        if(val=='pro'){
          this.$message.warning('”高品质“通道维护中')
          return false
        }
        this.mode = val
      },
      handleChooseDuration(val) {
        this.duration = val
      },
      handleChooseAspect(val) {
        this.aspect_ratio = val
      },
      handleJLCreate: throttle(function () {
        // this.handleCreate();
        this.$confirm('此操作将进行AI创作, 是否继续?', '提示（请勿重复提交）', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success'
        }).then(() => {
          this.handleCreate();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      }, 1000),
      handleCreate() {
        if (!this.getPlainText()) {
          this.$message.error('请输入描述词！')
          return false
        }
        const editableDiv = this.$refs.editableDiv;
        // 使用 textContent 获取纯文本
        const plainText = editableDiv.innerHTML;

        const jsonObj = {
          orgContent: plainText,
          orgChoosedList: JSON.stringify(this.choosedLgList)
        }
        const obj = {
          type: 'text',
          prompt: this.getPlainText(),
          negative_prompt: this.negative_prompt,
          cfg_scale: this.cfg_scale,
          mode: this.mode,
          duration: this.duration,
          aspect_ratio: this.aspect_ratio,
          // 原始数据
          org_data: JSON.stringify(jsonObj)
        }
        postVideoGenerate({...obj}).then(() => {
          this.$message.success('提交成功')
          this.handleCyDel()
          this.gGetVideoGenerate()
          this.$store.dispatch('updatePoints')
        }).catch(error => {
          this.$message.error(error.msg)
        })

      },

      // 记录光标位置
      saveCursorPosition() {
        const selection = window.getSelection();
        if (selection.rangeCount > 0) {
          // 保存当前的 Range 对象
          this.savedRange = selection.getRangeAt(0);
        }
      },

      // 恢复光标位置
      restoreCursorPosition() {
        if (this.savedRange) {
          const selection = window.getSelection();
          selection.removeAllRanges(); // 清除当前选区
          selection.addRange(this.savedRange); // 恢复保存的光标位置
        }
      },

      // 在光标位置插入按钮
      insertButton(item, item2) {

        const editableDiv = this.$refs.editableDiv;
        // 恢复光标位置
        this.restoreCursorPosition();

        // 获取当前光标位置
        const selection = window.getSelection();
        if (selection.rangeCount === 0) return; // 如果没有选中范围，直接返回

        const range = selection.getRangeAt(0); // 获取当前光标范围

        // 检查光标是否在 editableDiv 内部
        if (!editableDiv.contains(range.commonAncestorContainer)) {
          // console.warn('光标不在可编辑区域内');
          this.$message.error('光标不在可编辑区域内')
          return false;
        }


        item.popoverVisible = false
        const obj = {
          id: item2.name,
          is_multi: item2.is_multi,
          name: item.name
        }
        const index = this.choosedLgList.findIndex(ele => ele.name == item.name)
        if (index == -1) {
          this.updateOrAddItem(this.choosedLgList, obj)
        }
      },

      updateOrAddItem(arr, newItem) {
        // 遍历数组，查找是否存在具有相同 key 的对象
        const existingItemIndex = arr.findIndex(item => item.id == newItem.id);
        if (existingItemIndex !== -1) {
          // 如果找到了，替换该对象
          if (newItem.is_multi == 0) {
            const needThText = arr[existingItemIndex]
            arr[existingItemIndex] = newItem;
            // 替换
            this.replaceText(needThText, newItem)
          } else {
            arr.push(newItem);
            this.insertButton2(newItem)
          }
        } else {
          // 如果没有找到，新增该对象
          this.insertButton2(newItem)
          arr.push(newItem);
        }
      },
      insertButton2(item) {
        const editableDiv = this.$refs.editableDiv;
        // 恢复光标位置
        this.restoreCursorPosition();

        // 获取当前光标位置
        const selection = window.getSelection();
        if (selection.rangeCount === 0) return; // 如果没有选中范围，直接返回

        const range = selection.getRangeAt(0); // 获取当前光标范围

        // 检查光标是否在 editableDiv 内部
        if (!editableDiv.contains(range.commonAncestorContainer)) {
          this.$message.error('光标不在可编辑区域内')
          return;
        }

        const buttonId = `button-${this.buttonCount++}`;

        // 创建按钮的 HTML 元素
        const buttonWrapper = document.createElement('span');
        buttonWrapper.contentEditable = 'false'; // 设置为不可编辑
        buttonWrapper.id = buttonId;
        buttonWrapper.className = 'deletable-button';
        buttonWrapper.innerHTML = `<span class="lg-text">${item.name}</span><button class="delete-btn"></button>`;

        // 在光标位置插入按钮
        range.insertNode(buttonWrapper);

        // 将光标移动到插入内容的后面
        const newRange = document.createRange();
        newRange.setStartAfter(buttonWrapper);
        newRange.collapse(true); // 折叠范围到起始位置
        selection.removeAllRanges(); // 清除当前选区
        selection.addRange(newRange); // 设置新的选区

        // 绑定删除事件
        this.bindDeleteButtons();
        if (this.$refs.editableDiv.innerHTML.length > 0) {
          this.hasPlaceholder = false
        }
      },
      // 替换文本
      replaceText(needObj, item) {
        const editableDiv = this.$refs.editableDiv;


        const newText = `<span class="lg-text">${item.name}</span>`;
        const searchText = `<span class="lg-text">${needObj.name}</span>`;

        // 获取可编辑区域的内容
        let htmlContent = editableDiv.innerHTML;

        // 替换文本
        htmlContent = htmlContent.replace(searchText, newText);

        // 更新可编辑区域的内容
        editableDiv.innerHTML = htmlContent;

        // 更新 Vue 数据
        this.content = htmlContent;
      },


      // 绑定删除按钮的点击事件
      bindDeleteButtons() {
        // this.$refs.editableDiv.addEventListener('click', (event) => {
        //   if (event.target.classList.contains('delete-btn')) {
        //     event.stopPropagation();
        //     this.handleDeleteClick(event);
        //   }
        // });
        // 先移除之前的事件监听器，避免重复绑定
        this.$refs.editableDiv.removeEventListener('click', this.handleDeleteClick);
        // 重新绑定事件
        this.$refs.editableDiv.addEventListener('click', this.handleDeleteClick);
      },

      // 处理删除按钮的点击事件
      handleDeleteClick(event) {
        if (event.target.classList.contains('delete-btn')) {
          event.preventDefault(); // 阻止默认行为
          event.stopPropagation(); // 阻止事件冒泡
          const buttonElement = event.target.closest('.deletable-button');
          if (buttonElement) {
            const buttonString = buttonElement.outerHTML;
            const match = buttonString.match(/<span class="lg-text">(.*?)<\/span>/);
            const extractedText = match[1];
            if (extractedText) {
              const index = this.choosedLgList.findIndex(item => item.name == extractedText);
              if (index !== -1) {
                this.choosedLgList.splice(index, 1);
              }
            }
            buttonElement.remove();
          }
        }


        // event.preventDefault(); // 阻止默认行为
        // event.stopPropagation(); // 阻止事件冒泡
        // const buttonElement = event.target.closest('.deletable-button');
        // if (buttonElement) {
        //   const buttonString = buttonElement.outerHTML;
        //   const match = buttonString.match(/<span class="lg-text">(.*?)<\/span>/);
        //   const extractedText = match[1];
        //   console.log(extractedText);
        //   buttonElement.remove();
        // }
      },
      // 处理输入事件
      handleInput(event) {
        this.hasPlaceholder = false

        if (!event.target.innerHTML) {
          this.choosedLgList = []
        }
        const htmlContent = event.target.innerHTML
        // 正则表达式
        const pattern = /<span class="lg-text">(.*?)<\/span>/g;
        // 使用 match 方法提取内容
        const matches = htmlContent.match(pattern);
        if (matches && matches.length > 0) {
          const result = matches.map(match => match.replace(/<span class="lg-text">(.*?)<\/span>/, '$1'));
          const filteredArray = this.choosedLgList.filter(item => result.includes(item.name));
          this.choosedLgList = filteredArray
        }
        // 提取标签中的文本

      },
      handlePaste(e) {
        e.preventDefault();
        let text = '';
        let clp = (e.originalEvent || e).clipboardData;
        if (clp && clp.getData) {
          text = clp.getData('text/plain') || '';
        } else if (window.clipboardData && window.clipboardData.getData) {
          text = window.clipboardData.getData('text') || '';
        }
        if (text !== '') {
          if (document.queryCommandSupported('insertText')) {
            document.execCommand('insertText', false, text);
          } else {
            if (window.getSelection) {
              const newNode = document.createElement('span');
              newNode.innerHTML = text;
              window.getSelection().getRangeAt(0).insertNode(newNode);
            } else {
              document.selection.createRange().pasteHTML(text);
            }
          }
        }
      }
    },
    /**加载完组件时执行(加载完成之后执行)*/
    mounted() {

      this.pollingInterval = setInterval(this.gGetVideoGenerate, 15000);

      // 监听可编辑区域的 blur 事件，记录光标位置
      this.$refs.editableDiv.addEventListener('blur', this.saveCursorPosition);
      this.$refs.videoPlayer.muted = true;
      this.$refs.videoPlayer.play();
    },
    beforeDestroy() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
      }
      // 移除事件监听
      this.$refs.editableDiv.removeEventListener('blur', this.saveCursorPosition);
    }
  }
</script>

<style lang="scss" scoped>
  p {
    margin: 0;
    padding: 0;
  }

  .wsVideo-container {
    height: 100vh;
    width: 100%;
    position: relative;

    .tsv-title {
      font-weight: 500;
      font-size: 24px;
      color: #FFFFFF80;
      margin: 22px 40px;
    }
  }

  .ts-video-info-box {
    width: 1640px;
    height: 82vh;
    background: #191B2F;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    margin: 0 auto;
    font-size: 14px;
  }

  .ts-left-box {
    width: 400px;
    height: 100%;

    background: #191B2F;
    border-radius: 12px 0px 0px 12px;
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    position: relative;
    .gd-box::-webkit-scrollbar {
      display: none !important;
      width: 0 !important;
      height: 0 !important;
    }
    .gd-box {
      height: calc(100% - 110px);
      overflow-y: scroll;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* Internet Explorer 10+ */
    }


    .ts-left-header {
      width: 368px;
      height: 36px;
      background: rgba(255, 255, 255, 0.04);
      border-radius: 6px;
      margin: 16px auto 24px;

      .header1, .header2, .header3 {
        cursor: pointer;
        width: 50%;
        font-weight: 500;
        font-size: 14px;
        color: #EEEEEE80;
        line-height: 36px;
        text-align: center;
      }

      .active {
        color: #04C9C9 !important;
      }

      .header2 {
        position: relative;
      }

      .header2::before {
        position: absolute;
        z-index: 1;
        content: '';
        width: 1px;
        height: 14px;
        top: 11px;
        left: 0;
        background: #4A4B5B;
      }

      /*.header2::after {*/
      /*  position: absolute;*/
      /*  z-index: 1;*/
      /*  content: '';*/
      /*  width: 1px;*/
      /*  height: 14px;*/
      /*  top: 11px;*/
      /*  right: 0;*/
      /*  background: #4A4B5B;*/
      /*}*/
    }

    .title1 {
      width: 368px;
      margin: 24px auto 12px;
    }

    .ts-part1 {
      width: 368px;
      height: 283px;
      background: rgba(255, 255, 255, 0.02);
      border-radius: 8px;
      border: 1px solid rgba(255, 255, 255, 0.2);
      margin: 0 auto;
      padding: 16px;

      .part1-tip1 {
        font-weight: 400;
        font-size: 12px;
        color: #FFFFFF4d;
        text-align: left;
        margin-bottom: 12px;
      }

      .part1-md1 {
        .pic-s, .pic-w {
          width: 156px;
          height: 120px;
          background: #0D1027;
          border-radius: 6px;

          img {
            width: 32px;
            height: 32px;
            display: block;
            margin: 28px auto 5px;
          }

          p {
            text-align: center;
            color: #FAFAFAAA;
            font-size: 12px;

            span {
              cursor: pointer;
              font-weight: 400;
              color: #01FBF5;
              line-height: 22px;
              text-decoration-line: underline;
            }
          }
        }

        .zz-img {
          width: 24px;
          height: 24px;
          display: block;
          margin: 0 4px;
        }

        .has-img {
          width: 156px;
          height: 120px;
          background-size: 100% 100%;
          border-radius: 6px;
          padding: 50px;

          .hover-color:first-child {
            margin-right: 12px;
          }

          .hover-color {
            font-size: 18px;
          }

          .hover-color:hover {
            color: #01FBF5; /* 悬停时的颜色 */
          }
        }
      }

      .part1-md2 {
        margin: 15px 0 11px;

        .title2 {
          font-weight: 400;
          font-size: 12px;
          color: #EEEEEE80;
        }

        .refresh {
          width: 24px;
          height: 24px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 6px;
        }
      }


    }

    .part1-md3 {
      .every-md3-img {
        max-width: 120px;
        padding: 0 8px;
        height: 24px;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 4px;
        margin-right: 8px;

        font-weight: 400;
        font-size: 12px;
        color: #EEEEEE;
        line-height: 24px;
        text-align: center;
      }
    }

    .ts-part2 {
      width: 368px;
      margin: 12px auto;
      .cy-input-box::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
      }
      .cy-input-box {
        position: relative;
        font-size: 14px;
        width: 100%;
        height: 220px;
        padding: 10px 15px;
        background: #1f2237;
        color: #fff;
        border-radius: 4px;
        overflow-y: scroll;
        -ms-overflow-style: none; /* 对于IE和Edge */
        scrollbar-width: none; /* 对于FireFox */
        .editBox {
          width: 100%;
          height: 100%;
        }

        .placeholder-box {
          position: absolute;
          width: 100%;
          z-index: 1;
          color: #727485;
          pointer-events: none;
          font-size: 14px;
          top: 15px;
        }
      }

      .cy-handle-box {
        height: 30px;
        padding: 10px 15px;
        background: #1f2237;
        color: #fff;
        border-radius: 4px;

        .handle-box {
          width: 40px;
          height: 24px;
          background: #191B2F;
          border-radius: 6px;
          line-height: 24px;
          text-align: center;
        }
      }

      .ck-active {
        color: #6C14FF;
        font-weight: 600;
      }


    }

    .ts-part3 {
      color: #EEEEEEB3;
      width: 368px;
      margin: 0 auto 12px;

      .every-choose-box {
        cursor: pointer;
        width: 83px;
        height: 36px;
        background: rgba(255, 255, 255, 0.04);
        border-radius: 6px;

        font-weight: 400;
        font-size: 14px;
        color: #EEEEEEAA;
        line-height: 36px;
        text-align: center;
        margin-right: 12px;
      }

      .every-choose-active-box {
        border: 2px rgb(108, 20, 255) solid;
        color: #EEEEEE;
      }

      .every-bl-box {
        cursor: pointer;
        width: 83px;
        height: 72px;
        background: rgba(255, 255, 255, 0.04);
        border-radius: 6px;
        margin-right: 12px;
        text-align: center;

        .oneLl {
          margin: 15px auto 10px;
          width: 32px;
          height: 18px;
          background: rgba(255, 255, 255, 0.08);
          border-radius: 2px;
          border: 1px solid rgba(250, 250, 250, 0.2);
        }

        .twoLl {
          margin: 10px auto 6px;
          width: 18px;
          height: 32px;
          background: rgba(255, 255, 255, 0.08);
          border-radius: 2px;
          border: 1px solid rgba(255, 255, 255, 0.2);
        }

        .threeLl {
          margin: 14px auto 6px;
          width: 28px;
          height: 28px;
          background: rgba(255, 255, 255, 0.08);
          border-radius: 2px;
          border: 1px solid rgba(255, 255, 255, 0.2);
        }
      }
    }

    .no-xq-box {
      width: 368px;
      margin: 0 auto 24px;
    }

    .ts-part4 {
      position: absolute;
      z-index: 1;
      bottom: 0;
      width: 400px;
      height: 96px;
      background: #191B2F;
      border-radius: 0px 0px 0px 12px;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      border-right: 1px solid rgba(255, 255, 255, 0.1);

      .btn-hc {
        width: 352px;
        height: 48px;
        background: linear-gradient(312deg, #6C14FF 0%, #01FBF5 100%);
        border-radius: 8px;

        font-weight: 600;
        font-size: 18px;
        color: #FFFFFF;
        line-height: 48px;
        text-align: center;
      }
    }
  }

  .ts-middle-box {
    width: 963px;
    height: 100%;

    .no-video-info {
      font-weight: 400;
      font-size: 16px;
      color: #FFFFFFAA;
      text-align: center;
      margin-bottom: 250px;

      img {
        display: block;
        width: 99px;
        height: 85px;
        margin: calc(41vh - 80px) auto 23px;
      }
    }

    .has-video-box {
      width: 800px;
      height: 500px;
      background: #1f2237;
      border-radius: 16px;
      margin: calc(50vh - 350px) auto 0;

      .video-part1 {
        width: 800px;
        height: 440px;
        background: #1f2237;
        border-radius: 16px;
      }

      .video-part2 {
        width: 800px;
        height: 60px;
        background: #1f2237;
        border-radius: 16px;

        .handle-box {
          width: 50px;
          height: 30px;
          background: #191B2F;
          border-radius: 16px;
          line-height: 30px;
          text-align: center;
          margin-right: 15px;
        }

      }
    }

    .tip-box {
      text-align: center;
      color: #c5c7d5AA;
      font-size: 13px;
      margin-top: 50px;
    }
  }
  .ts-right-box::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  .ts-right-box {
    width: 253px;
    height: 100%;
    overflow-y: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    background: #191B2F;
    border-radius: 12px 0px 0px 12px;
    border-left: 1px solid rgba(255, 255, 255, 0.1);
    padding: 26px 16px;

    .ts-part5 {
      font-weight: 500;
      font-size: 16px;
      color: #EEEEEE;

      img {
        width: 20px;
        height: 20px;
      }
    }

    .no-history, .proceed-ing {
      margin-top: 16px;
      width: 213px;
      height: 120px;
      background: #26283B;
      border-radius: 12px;
      line-height: 120px;
      font-weight: 400;
      font-size: 14px;
      color: #FFFFFFAA;
      text-align: center;
    }

    .proceed-ing {
      line-height: 20px;
    }

    .video-active {
      border: 2px #6c14ff solid;
      color: #EEEEEE;
    }

    .success-video {
      width: 213px;
      height: 120px;
      position: relative;
      border-radius: 12px;

      img {
        width: 97%;
        height: 100%;
        object-fit: contain;
        border-radius: 12px;
      }

      .time-text {
        position: absolute;
        left: 10px;
        bottom: 10px;
      }

      .down-box {
        position: absolute;
        right: 10px;
        bottom: 10px;
      }
    }

    .fail-video {
      width: 213px;
      height: 120px;
      position: relative;

      img {
        width: 36px;
        height: 36px;
      }

      .fail-del-box {
        position: absolute;
        right: 10px;
        bottom: 10px;
      }
    }

  }


</style>
<style lang="scss">

  .custom-popover {
    background-color: rgb(48, 51, 70); /* 修改背景颜色 */
    border: none;

  }

  .custom-popover .el-popover__title {
    color: #333; /* 修改标题颜色 */
    font-size: 16px; /* 修改标题字体大小 */
  }

  .custom-popover img {
    width: 100%; /* 修改图片宽度 */
    height: auto;
    object-fit: contain;
  }

  .no-xq-box .el-textarea__inner {
    background: #191B2F;
    border-color: rgba(255, 255, 255, 0.2);
    color: #FFFFFF;
  }

  .custom-popover .popper__arrow {
    border-right-color: #303346 !important;
  }

  .custom-popover .popper__arrow::after {
    border-right-color: #303346 !important;
  }

  .custom-popover2 {
    background-color: rgb(48, 51, 70) !important; /* 修改背景颜色 */
    border: none !important;
  }

  .custom-popover2 .popper__arrow {
    border-top-color: #303346 !important;
  }

  .custom-popover2 .popper__arrow::after {
    border-top-color: #303346 !important;
  }

  .custom-popover {
    .lg-title-box {
      padding: 10px;
      width: 100%;
      font-size: 15px;
      color: #ffffff4d;
    }

    .lg-title-active {
      color: #ffffff;
      border-bottom: 2px solid #6C13FF;
    }

    .ling-gan-pro {
      width: 100%;

      .every-lg-box {
        cursor: pointer;
        padding: 4px 12px;
        color: #ffffff4d;
        margin-right: 12px;

        p {
          margin-bottom: 10px;
        }

        .every-ele-box {
          height: 24px;
          background: rgba(255, 255, 255, 0.05);
          margin: 0 10px 8px 0;
          border-radius: 4px;
          font-weight: 400;
          font-size: 12px;
          color: #EEEEEE;
          line-height: 24px;
          text-align: center;

          .every-lg-p {
            padding: 0 8px;
            border-radius: 4px;
          }

          .choosed-active-lg {
            color: #E3D4FC;
            background: #6C14FF4d;
          }
        }
      }
    }
    .my-ys-box::-webkit-scrollbar {
      display: none !important;
      width: 0 !important;
      height: 0 !important;
    }
    .my-ys-box {
      margin: 0 10px 8px 0;
      min-height: 300px;
      max-height: 500px;
      overflow-y: scroll;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* Internet Explorer 10+ */
      .ys-list-box {
        margin-top: 12px;

        .every-ys-box {
          width: 100%;
          height: 80px;
          background: rgba(255, 255, 255, 0.02);
          border-radius: 6px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          margin-bottom: 12px;
          position: relative;
          padding: 8px 16px;
          font-size: 14px;

          p:first-child {
            color: #FAFAFA;
            margin-bottom: 5px;
          }

          p:last-child {
            color: #FAFAFAAA;
          }

          .del-box {
            width: 32px;
            height: 32px;
            position: absolute;
            top: 4px;
            right: 4px;
            z-index: 1;
          }
        }
      }
    }
  }

  .every-ele-box {
    video {
      width: 100%; /* 设置视频宽度 */
      height: auto; /* 保持视频比例 */
      object-fit: cover; /* 填充整个容器 */
    }

    /* 禁用控制条（如果需要进一步确保隐藏） */
    video::-webkit-media-controls {
      display: none !important;
    }

    video::-webkit-media-controls-enclosure {
      display: none !important;
    }

    video::-webkit-media-controls-panel {
      display: none !important;
    }
  }

  .deletable-button {
    color: #E3D4FC;
    background: #6C14FF4d;
    padding: 4px 16px 4px 10px;
    border-radius: 4px;
    margin: 5px;
    white-space: nowrap;

    .delete-btn {
      border: none;
      background: transparent;
      cursor: pointer;
      padding: 0;
      margin-left: 5px;
      color: #ffffffAA;
      font-size: 12px;
      position: relative;
    }

    .delete-btn::before {
      content: '';
      position: absolute;
      z-index: 1;
      right: -10px;
      bottom: -1px;
      width: 12px;
      height: 12px;
      background-image: url('https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/xinBan/wsVideoclose.png');
      background-size: cover;
    }
  }

  .my-ys-box {
    .el-input__inner {
      background: #191B2F;
      border: none;
      color: #eeeeee;
    }

    .el-button {
      background: #191B2F;
      color: #eeeeee;
      border: none;
    }

    .el-button:hover {
      color: #ffffff;
      border-color: #c6e2ff;
      background-color: #191B2F;
    }

  }

  .wsVideo-container {
    .el-dialog {
      background: #20212C;
    }

    .el-dialog__title {
      color: #ffffff;
    }

    .el-dialog__body {
      margin-top: 0;
      padding-top: 10px;
    }
  }

  .dialogInfo {
    .el-input__inner, .el-textarea__inner {
      background: transparent;
      border: 1px rgba(255, 255, 255, 0.2) solid;
      color: #eeeeee;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/wsVideo.vue